export default class {
  debugMode = false;
  controllers = {};


  reset() {
    Object.keys(this.controllers).forEach((key) => {
      delete this.controllers[key];
    });
    return this;
  }


  clean() {
    Object.keys(this.controllers).forEach((key) => {
      if (!this.controllers[key]) {
        delete this.controllers[key];
      }
    });
    return this;
  }


  log(...data) {
    if (this.debugMode) {
      console.debug(data);
    }
  }


  abort(name) {
    const controller = this.get(name);
    this.log('abort', { controller });

    if (controller) {
      controller.abort();
    }
    return this;
  }


  set(name, value = null) {
    this.log('set', { name, value });
    this.controllers[name] = value;
    return this;
  }


  get(name) {
    const value = this.controllers[name] || null;
    this.log('get', { name, value });
    return value;
  }
}

